import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import Select from '../../../Forms/Commons/Select'

class Address extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,

        placeFieldName: PropTypes.string.isRequired,
        countryFieldName: PropTypes.string.isRequired,
        countries: PropTypes.array.isRequired,
        departmentFieldName: PropTypes.string.isRequired,
        departments: PropTypes.array.isRequired,

        placeLabel: PropTypes.string.isRequired,
        departmentLabel: PropTypes.string.isRequired,
        countryLabel: PropTypes.string.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.state = {
            departmentsDisabled: ! this.isFrance(props.fields[props.countryFieldName]),
        }

        this.handleUpdateFieldValue = this.handleUpdateFieldValue.bind(this)
        this.handleUpdateCountryFieldValue = this.handleUpdateCountryFieldValue.bind(this)
        this.updateDepartmentsEnabledState = this.updateDepartmentsEnabledState.bind(this)

        this.mainField = React.createRef()
    }

    handleUpdateFieldValue(field, value)
    {
        this.props.resetInvalidField(field)
        this.props.updateFieldValue(field, value)
    }

    handleUpdateCountryFieldValue(field, value)
    {
        this.updateDepartmentValueDependingOnCountry(value)
        this.updateDepartmentsEnabledState(value)
        this.handleUpdateFieldValue(field, value)
    }

    isFrance(country)
    {
        return country === 'france'
    }

    updateDepartmentsEnabledState(country)
    {
        this.setState({departmentsDisabled: ! this.isFrance(country)})
    }

    updateDepartmentValueDependingOnCountry(country)
    {
        if(this.isFrance(country))
        {
            return
        }

        this.props.updateFieldValue(this.props.departmentFieldName, 'other')
    }

    componentDidMount()
    {
        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    render()
    {
        const {
            t, fields, isInvalidField,
            placeFieldName, placeLabel,
            countryFieldName, countryLabel,
            countries,
            departmentFieldName,
            departmentLabel,
            departments,
        } = this.props

        return (
            <React.Fragment>
                <div className={'form-group'}>
                    <label htmlFor={placeFieldName}>{placeLabel}</label>
                    <input
                        id={placeFieldName}
                        ref={this.mainField}
                        defaultValue={fields[placeFieldName]}
                        onChange={ event => this.handleUpdateFieldValue(placeFieldName, event.target.value) }
                        type={ 'text' }
                        className={classNames({'error': isInvalidField(placeFieldName)})}
                    />
                </div>

                <div className={'form-group'}>
                    <label htmlFor={departmentFieldName}>{departmentLabel}</label>
                    <div title={this.state.departmentsDisabled ? t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.department.noAvailable') : ''}>
                        <Select
                            id={departmentFieldName}
                            options={departments}
                            value={fields[departmentFieldName]}
                            onChange={option => this.handleUpdateFieldValue(departmentFieldName, option.value)}
                            isDisabled={this.state.departmentsDisabled}
                            isSearchable={true}
                            doNotFilterValue={'other'}
                            className={classNames({"error": isInvalidField(departmentFieldName)})}
                        />
                    </div>
                </div>

                <div className={'form-group'}>
                    <label htmlFor={countryFieldName}>{countryLabel}</label>
                    <Select
                        id={countryFieldName}
                        options={countries}
                        value={fields[countryFieldName]}
                        onChange={option => this.handleUpdateCountryFieldValue(countryFieldName, option.value)}
                        isSearchable={true}
                        doNotFilterValue={'other'}
                        className={classNames({"error": isInvalidField(countryFieldName)})}
                    />
                </div>

            </React.Fragment>
        )
    }
}

export default withTranslation()(Address)
